/**
 * Replo sticky ATC — hidden until [data-component="quantity-atc"] is scrolled past.
 * Replo owns layout/styles; we only add slide-in/out via .gnu-sticky-atc--visible.
 * body.gnu-has-sticky-atc mirrors it so other fixed-bottom UI can move out of the way.
 */
(function () {
  if (window.__gnuStickyAtcInit) return;
  window.__gnuStickyAtcInit = true;

  var GNU_STICKY_ATC_VERSION = '2026-10-27.1';
  var GNU_STICKY_ATC_DEBUG = false;
  var TRIGGER_SELECTOR = '[data-component="quantity-atc"]';
  var STICKY_SELECTOR = '[data-component="sticky-atc"]';
  var REPLO_ROOT_SELECTOR = '#replo-fullpage-element';
  var VISIBLE_CLASS = 'gnu-sticky-atc--visible';
  var BODY_CLASS = 'gnu-has-sticky-atc';
  /* Alia's root has no stable class: its id carries the flow id and its inline
     style is rewritten per state. Only the bottom-left teaser has
     `bottom: 16px` (the open popup is `inset: 0px`), so this skips the modal. */
  var ALIA_TEASER_SELECTOR = '[id^="alia-root-"][style*="bottom: 16px"]';
  var POLL_MS = 250;
  var IDLE_STOP_MS = 30000;

  function log() {
    if (!GNU_STICKY_ATC_DEBUG) return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift('[gnu-sticky-atc]');
    console.log.apply(console, args);
  }

  var style = document.createElement('style');
  style.id = 'gnu-sticky-atc-styles';
  style.textContent = [
    '[data-component="sticky-atc"] {',
    '  transform: translateY(100%) !important;',
    '  opacity: 0 !important;',
    '  visibility: hidden !important;',
    '  pointer-events: none !important;',
    '  transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.35s ease, visibility 0.35s !important;',
    '}',
    '',
    '[data-component="sticky-atc"].' + VISIBLE_CLASS + ' {',
    '  transform: translateY(0) !important;',
    '  opacity: 1 !important;',
    '  visibility: visible !important;',
    '  pointer-events: auto !important;',
    '}',
    '',
    /* !important: Alia's own `#alia-root-<id> { all: initial }` outranks us. */
    ALIA_TEASER_SELECTOR + ' {',
    '  transition: bottom 0.35s cubic-bezier(0.4, 0, 0.2, 1) !important;',
    '}',
    '',
    'body.' + BODY_CLASS + ' ' + ALIA_TEASER_SELECTOR + ' {',
    '  bottom: 84px !important;',
    '}',
    '',
    '@media (prefers-reduced-motion: reduce) {',
    '  [data-component="sticky-atc"] { transition: none !important; }',
    '  ' + ALIA_TEASER_SELECTOR + ' { transition: none !important; }',
    '}',
  ].join('\n');

  if (!document.getElementById(style.id)) {
    (document.head || document.documentElement).appendChild(style);
  }
  log('styles injected', { version: GNU_STICKY_ATC_VERSION });

  var state = {
    booted: false,
    bound: false,
    triggerEl: null,
    stickyEl: null,
    intersectionObserver: null,
    onChange: null,
    pollId: null,
    mutationObserver: null,
    startedAt: 0,
    lastStatusLogAt: 0,
  };

  function findElements() {
    return {
      trigger: document.querySelector(TRIGGER_SELECTOR),
      sticky: document.querySelector(STICKY_SELECTOR),
    };
  }

  function isTargetPage() {
    var els = findElements();
    return !!(els.trigger || els.sticky || document.querySelector(REPLO_ROOT_SELECTOR));
  }

  function isScrolledPastTrigger(triggerEl) {
    if (!triggerEl) return false;
    return triggerEl.getBoundingClientRect().bottom <= 0;
  }

  function updateVisibility(triggerEl, stickyEl) {
    if (!triggerEl || !stickyEl) return;
    if (!document.contains(triggerEl) || !document.contains(stickyEl)) {
      log('bound nodes removed from DOM, will re-bind');
      teardownBinding();
      tryBind();
      return;
    }

    var show = isScrolledPastTrigger(triggerEl);
    var wasVisible = stickyEl.classList.contains(VISIBLE_CLASS);

    if (show && !wasVisible) {
      stickyEl.classList.add(VISIBLE_CLASS);
      document.body.classList.add(BODY_CLASS);
      log('show sticky ATC — quantity-atc scrolled past');
    } else if (!show && wasVisible) {
      stickyEl.classList.remove(VISIBLE_CLASS);
      document.body.classList.remove(BODY_CLASS);
      log('hide sticky ATC — quantity-atc in or above view');
    }
  }

  function teardownBinding() {
    /* A re-rendered sticky starts without VISIBLE_CLASS, so drop the body
       class too or a scrolled-up re-bind would never clear it. */
    if (document.body) document.body.classList.remove(BODY_CLASS);
    if (state.intersectionObserver) {
      state.intersectionObserver.disconnect();
      state.intersectionObserver = null;
    }
    if (state.onChange) {
      window.removeEventListener('scroll', state.onChange);
      window.removeEventListener('resize', state.onChange);
      state.onChange = null;
    }
    state.bound = false;
    state.triggerEl = null;
    state.stickyEl = null;
  }

  function bind(triggerEl, stickyEl) {
    log('bound observers', { trigger: triggerEl, sticky: stickyEl });

    state.bound = true;
    state.triggerEl = triggerEl;
    state.stickyEl = stickyEl;

    state.onChange = function () {
      updateVisibility(triggerEl, stickyEl);
    };

    if ('IntersectionObserver' in window) {
      state.intersectionObserver = new IntersectionObserver(
        state.onChange,
        { threshold: [0, 0.01, 1] }
      );
      state.intersectionObserver.observe(triggerEl);
    }

    window.addEventListener('scroll', state.onChange, { passive: true });
    window.addEventListener('resize', state.onChange, { passive: true });
    state.onChange();
  }

  function tryBind() {
    var els = findElements();

    if (!els.trigger || !els.sticky) {
      return false;
    }

    if (
      state.bound &&
      state.triggerEl === els.trigger &&
      state.stickyEl === els.sticky &&
      document.contains(els.trigger) &&
      document.contains(els.sticky)
    ) {
      return true;
    }

    if (state.bound) {
      log('re-binding after DOM change');
      teardownBinding();
    }

    bind(els.trigger, els.sticky);
    return true;
  }

  function logWaitingStatus() {
    var now = Date.now();
    if (now - state.lastStatusLogAt < 2000) return;
    state.lastStatusLogAt = now;

    var els = findElements();
    log('still waiting for elements', {
      trigger: !!els.trigger,
      sticky: !!els.sticky,
      reploRoot: !!document.querySelector(REPLO_ROOT_SELECTOR),
      elapsedMs: now - state.startedAt,
    });
  }

  function stopDiscovery(reason) {
    if (state.pollId) {
      clearInterval(state.pollId);
      state.pollId = null;
    }
    if (state.mutationObserver) {
      state.mutationObserver.disconnect();
      state.mutationObserver = null;
    }
    log(reason);
  }

  function startDiscovery() {
    if (state.pollId || state.mutationObserver) return;

    state.startedAt = Date.now();
    log('discovery started', {
      version: GNU_STICKY_ATC_VERSION,
      readyState: document.readyState,
    });

    state.pollId = setInterval(function () {
      if (tryBind()) {
        /* Bound. The observer below still catches Replo re-renders, so the poll
           has nothing left to do — and on a product page stopDiscovery() never
           fires, so leaving it running costs a findElements() sweep every 250ms
           for the entire life of the page. */
        clearInterval(state.pollId);
        state.pollId = null;
        log('discovery poll stopped — bound');
        return;
      }

      var elapsed = Date.now() - state.startedAt;
      if (!isTargetPage() && elapsed >= IDLE_STOP_MS) {
        stopDiscovery('stopped — not a replo product page');
        return;
      }

      logWaitingStatus();
    }, POLL_MS);

    /* attributeFilter includes `class`, which churns constantly on a Replo page
       (hover, scroll animations, carousels). Coalesce to one findElements()
       sweep per frame instead of one per attribute change. */
    var bindPending = false;
    state.mutationObserver = new MutationObserver(function () {
      if (bindPending) return;
      bindPending = true;
      requestAnimationFrame(function () {
        bindPending = false;
        tryBind();
      });
    });

    var observeRoot = document.querySelector(REPLO_ROOT_SELECTOR) || document.documentElement;
    state.mutationObserver.observe(observeRoot, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-component', 'class', 'id'],
    });

    window.addEventListener('load', tryBind);
    tryBind();
  }

  function boot() {
    if (state.booted) return;
    state.booted = true;
    log('boot', {
      version: GNU_STICKY_ATC_VERSION,
      readyState: document.readyState,
    });
    startDiscovery();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  }
  boot();

  window.__gnuStickyAtc = {
    version: GNU_STICKY_ATC_VERSION,
    getState: function () {
      var els = findElements();
      return {
        bound: state.bound,
        trigger: !!els.trigger,
        sticky: !!els.sticky,
        reploRoot: !!document.querySelector(REPLO_ROOT_SELECTOR),
      };
    },
    retry: tryBind,
  };
})();
